/**
 * pingMinimapMarkers — Active ping stubs as minimap markers (SPY-314).
 * Domain-only; presentation paints kind ping.
 */

/**
 * @param {Array<{ id?: string, type?: string, x?: number, z?: number }>|null} [pings]
 * @returns {{ id: string, kind: string, pingType: string, x: number, z: number }[]}
 */
export function buildPingMinimapMarkers(pings = []) {
  if (!Array.isArray(pings)) return [];
  const markers = [];
  for (const ping of pings) {
    if (!ping) continue;
    markers.push({
      id: ping.id || `ping-${markers.length}`,
      kind: 'ping',
      pingType: ping.type || 'danger',
      x: ping.x || 0,
      z: ping.z || 0
    });
  }
  return markers;
}
